module.exports = __webpack_public_path__ + "img/ChTradicional-studio.d462344f.gif";